import React from 'react'
import styled from 'styled-components'
import { Button } from 'antd'
import { ClientEditIcon } from '../../../asserts/svgWrappers/facilityIcons'
import { ScoreColorGroupStyle } from '../index.styled'
import { RangeColors } from '../../../utils'

export const CircleEditButton = styled(Button).attrs((props) => ({
  type: 'text',
  icon: <ClientEditIcon />
}))`
  width: 36px;
  height: 36px;
  box-shadow: none;
  padding: 0;
  border: none;
`

const { red, orange, yellow, green, emerald } = RangeColors

const Tips = {
  muscle: [
    {
      name: 'poor',
      color: red
    },
    {
      name: 'fair',
      color: orange
    },
    {
      name: 'good',
      color: yellow
    },
    {
      name: 'Very good',
      color: green
    },
    {
      name: 'Excellent',
      color: emerald
    }
  ],
  movement: [
    {
      name: 'poor',
      color: red
    },
    {
      name: 'fair',
      color: orange
    },
    {
      name: 'good',
      color: yellow
    },
    {
      name: 'optimal',
      color: green
    }
  ],
  balance: [
    {
      name: 'poor',
      color: red
    },
    {
      name: 'fair',
      color: orange
    },
    {
      name: 'good',
      color: yellow
    },
    {
      name: 'optimal',
      color: green
    }
  ]
}

export const ScoreColorGroup = (props) => {
  return (
    <ScoreColorGroupStyle>
      {Tips[props.domain].map((item, index) => (
        <li key={index}>
          <span style={{ background: item.color }} /> {item.name}
        </li>
      ))}
    </ScoreColorGroupStyle>
  )
}
